var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 24,
    viewBox: "0 0 68 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.25H20.75V12.75H20V12V11.25ZM0 12L7.5 7.66987V16.3301L0 12ZM20 12V12.75H6.75V12V11.25H20V12Z",
    fill: "#4F46E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7551 13.485L32.7551 16.4892M32.7551 16.4892L32.7551 19.9954C32.7551 20.8264 32.0828 21.5 31.2534 21.5C30.424 21.5 29.7516 20.8264 29.7516 19.9954L29.7516 14.531M32.7551 16.4892L33.8095 16.4624C34.5205 16.4443 35.1371 16.056 35.4774 15.4844M29.7516 14.531L29.7516 9.96807M29.7516 14.531L27.1582 11.7712C25.5857 9.90362 26.412 8.54219 26.9923 7.78577L28.6071 5.34841C29.832 3.28085 31.2493 2.5 32.4416 2.5L37.3223 2.5C39.5884 2.5 41.7014 4.88227 41.7014 7.06579L41.7495 12.2657C41.7588 13.2759 41.0161 14.135 40.0168 14.27L38.4764 14.4593M35.4774 15.4844C35.6561 15.1842 35.7587 14.8335 35.7587 14.4593L35.7587 13.4552M35.4774 15.4844L36.813 15.4297C37.8975 15.4021 38.7622 14.5134 38.7622 13.4266L38.7622 12.4226",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 11.25H47.25V12.75H48V12V11.25ZM68 12L60.5 7.66987V16.3301L68 12ZM48 12V12.75H61.25V12V11.25H48V12Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.40925a8afe3fb0822287b835990ed6f2.svg";
export { ForwardRef as ReactComponent };